<script setup lang="ts">
import { computed } from 'vue'
import { SpinnerVariant } from './types'

interface Props {
  variant?: keyof typeof SpinnerVariant
  size?: number
  weight?: number
}

const props = withDefaults(defineProps<Props>(), {
  variant: SpinnerVariant.default,
  size: 8,
  weight: 4,
})

interface ValueMap<T> { [index: number]: T }

const spinnerClass = computed(() => {
  const size: ValueMap<string> = {
    2: 'h-2 w-2',
    3: 'h-3 w-3',
    4: 'h-4 w-4',
    5: 'h-5 w-5',
    6: 'h-6 w-6',
    7: 'h-7 w-7',
    8: 'h-8 w-8',
    9: 'h-9 w-9',
    10: 'h-10 w-10',
    11: 'h-11 w-11',
    12: 'h-12 w-12',
  }

  const weight: ValueMap<string> = {
    2: 'border-2',
    4: 'border-4',
  }

  return [
    size[props.size],
    weight[props.weight],
    props.variant === SpinnerVariant.white
      ? 'border-white'
      : 'border-gray-800',
    'border-t-transparent',
  ]
})
</script>

<template>
  <div
    class="inline-block animate-spin rounded-full"
    :class="spinnerClass"
  />
</template>
